module.exports = __webpack_public_path__ + "img/thumbnail_AldabraGiantTortoise_f_normal.46650e52.png";